export default __webpack_public_path__ + "static/media/1044.478b5819.png";